import { useEffect, useState } from "react";
import { api } from "@/lib/api";

import { dispDT } from "@/lib/api";

export const SimBanner = () => {
  const [sim, setSim] = useState(null);
  useEffect(() => {
    const fetchT = () => api.get("/time/now").then((r) => setSim(r.data)).catch(() => {});
    fetchT();
    const id = setInterval(fetchT, 30000);
    return () => clearInterval(id);
  }, []);
  if (!sim?.is_sim) return null;
  return (
    <div
      className="banner-sim text-center py-2 text-sm px-4"
      data-testid="sim-banner"
    >
      ⚠ MODE SIMULASI AKTIF — Waktu: {dispDT(sim.now)}
    </div>
  );
};
